








import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ConditionalFreeContentsContainer from '@ajax/vue/components/organisms/free-contents/ConditionalFreeContentsContainer.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ConditionalFreeContentsContainer,
  },
})
export default class ShipmentSuspendNotification extends Vue {
  /**
   * ホスト配下では明示的にnullを渡すこと
   */
  @Prop({ required: true })
  readonly brandEnglishName: string | null

  get currentPath(): string {
    return location.pathname
  }

  get behaviorConfig(): BehaviorConfig {
    return this.brandEnglishName ?
      BehaviorConfig.createFromBrand(this.brandEnglishName) :
      BehaviorConfig.forHost
  }

  get isEnabled(): boolean {
    return this.behaviorConfig.shipmentSuspendNotification.enabledOn(this.currentPath)
  }
}
